import gql from 'graphql-tag';

import type { UtilityContext } from '@change/core/react/utilityContext';

import type { EmbeddedMediaQuery, EmbeddedMediaQueryVariables } from './getIframelyData.graphql';

const query = gql`
	query EmbeddedMedia($input: GetEmbeddedMediaInput!) {
		embeddedMedia: getEmbeddedMedia(input: $input) {
			success
			objectData
		}
	}
`;

type IframelyResponse = {
	html: string;
};

// https://iframely.com/docs/parameters
type IframelyOptions = Omit<EmbeddedMediaQueryVariables['input'], 'params'>;

// Params are passed to Iframely to customize style.
// Response type is something that extends IframelyResponse - Iframely might respond with different data per URL,
// but there's always at least a "html" property.
// Iframely doc: https://iframely.com/docs/oembed-api
export async function getIframelyData<RESPONSE extends IframelyResponse = IframelyResponse>(
	options: IframelyOptions,
	{ gql: { fetch } }: UtilityContext,
): Promise<RESPONSE> {
	const { data } = await fetch<EmbeddedMediaQuery>({
		query,
		variables: {
			input: options,
		},
		rejectOnError: true,
	});

	if (!data?.embeddedMedia || !data.embeddedMedia.success) throw new Error('media fetch failed');

	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	return data.embeddedMedia.objectData as RESPONSE;
}
